import {
  closeDraftAgencyChat,
  openDraftAgencyChat,
  setDraftAgencyChatPanelWidth,
  toggleDraftAgencyChat,
} from '@saaga/shared/store/slices/draft-agency-chat.slice'
import { useAppDispatch, useAppSelector } from '@saaga/shared/store/store'
import { useCallback } from 'react'

export interface DraftAgencyChatPanelHandlers {
  handleOpen: () => void
  handleClose: () => void
  handleToggle: () => void
  handleResize: (deltaX: number) => void
}

export interface UseDraftAgencyChatHandlersProps {
  agencyId: string
}

export const useDraftAgencyChatHandlers = ({
  agencyId,
}: UseDraftAgencyChatHandlersProps): DraftAgencyChatPanelHandlers => {
  const dispatch = useAppDispatch()
  const panelWidth = useAppSelector((s) => s.draftAgencyChat.panelWidth)

  const handleOpen = useCallback(
    () => dispatch(openDraftAgencyChat({ agencyId })),
    [dispatch, agencyId]
  )
  const handleClose = useCallback(() => dispatch(closeDraftAgencyChat()), [dispatch])
  const handleToggle = useCallback(() => dispatch(toggleDraftAgencyChat()), [dispatch])
  const handleResize = useCallback(
    (d: number) => dispatch(setDraftAgencyChatPanelWidth({ width: panelWidth - d })),
    [dispatch, panelWidth]
  )

  return { handleOpen, handleClose, handleToggle, handleResize }
}
